import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';

import { RootType } from '../../typings';
import { HINT_KIND, HintData, HintInnerData } from '../wizard/typings';

import HintTypeCallToAction, { Props as CTAProps } from './_type/hint_type_call-to-action';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type IncludedData = Record<string, any>;

interface Props extends CTAProps {
    id: string;
    onClose: (params?: { additionalData: object }) => void;
    setWizardHints: (params: HintData) => void;
    type: HINT_KIND;
    viewedCount?: number;
    countViews?: boolean;
    includedData?: IncludedData;
}

export const Hint = ({ type, onClose, ...hintProps }: Props) => {
    switch (type) {
        case HINT_KIND.CALL_TO_ACTION:
        default:
            return <HintTypeCallToAction {...hintProps} onClose={onClose} />;
    }
};

Hint.defaultProps = {
    type: HINT_KIND.CALL_TO_ACTION,
};

const mapDispatchToProps = (
    dispatch: Dispatch<RootType>,
    { id, onClose, setWizardHints, viewedCount = 0, countViews, includedData }: Props
) => {
    return bindActionCreators(
        {
            onClose: ({ additionalData } = {}) => {
                if (onClose) {
                    onClose();
                }

                const hintInnerData: HintInnerData = {
                    viewedDate: new Date().toISOString(),
                };

                if (countViews) {
                    hintInnerData.viewedCount = viewedCount + 1;
                }

                return setWizardHints({
                    [id]: {
                        ...hintInnerData,
                        ...includedData,
                        ...additionalData,
                    },
                });
            },
        },
        dispatch
    );
};

//@ts-ignore
export default connect(null, mapDispatchToProps)(Hint);
